const translations = {
  "de-CH": {
    // Nav
    "nav.dashboard": "Dashboard",
    "nav.companies": "Firmen",
    "nav.media": "Medienbibliothek",
    "nav.content_create": "Content erstellen",
    "nav.weekly_planner": "Wochenplaner",
    "nav.campaigns": "Kampagnen",
    "nav.approval": "Freigabe",
    "nav.inbox": "Social-Inbox",
    "nav.calendar": "Kalender",
    "nav.performance": "Performance",
    "nav.ads_manager": "Ads Manager",
    "nav.group": "InvictaX Gruppe",
    "nav.leads": "Leads",
    "nav.google_ads": "Google Ads",
    "nav.ab_tests": "A/B Tests",
    "nav.competitors": "Wettbewerber",
    "nav.team": "Team",
    "nav.templates": "Prompt-Templates",
    "nav.providers": "Modell-Routing",
    "nav.social_media": "Social Media",
    "nav.section_content": "Content",
    "nav.section_analytics": "Analyse & Team",
    "nav.section_settings": "Einstellungen",
    "nav.logout": "Abmelden",
    // Login
    "login.title": "InvictaFlow Marketing",
    "login.welcome": "Willkommen",
    "login.subtitle": "Melde dich an, um das InvictaX Marketing OS zu verwalten.",
    "login.google_btn": "Mit Google anmelden",
    "login.footer": "Multi-Brand Content Management mit KI",
    // Dashboard
    "dashboard.title": "Dashboard",
    "dashboard.subtitle": "Ueberblick ueber dein Marketing OS",
    "dashboard.companies": "Firmen",
    "dashboard.media": "Medien",
    "dashboard.content": "Content",
    "dashboard.in_review": "Zur Pruefung",
    "dashboard.scheduled": "Geplant",
    "dashboard.published": "Veroeffentlicht",
    "dashboard.campaigns": "Kampagnen",
    "dashboard.season_banner": "Aktuelle Themen",
    "dashboard.recent_content": "Neueste Inhalte",
    "dashboard.no_content": "Noch keine Inhalte erstellt. Starte mit \"Content erstellen\".",
    "dashboard.topic_suggestions": "Themenvorschlaege",
    "dashboard.select_company": "Firma waehlen",
    "dashboard.suggestions_btn": "Vorschlaege",
    "dashboard.suggestions_empty": "Waehle eine Firma und klicke \"Vorschlaege\" fuer KI-gestuetzte Themenideen.",
    // Companies
    "companies.title": "Firmenverwaltung",
    "companies.subtitle": "Verwalte deine Firmen und deren Markenprofile",
    "companies.add_btn": "Firma hinzufuegen",
    "companies.edit_title": "Firma bearbeiten",
    "companies.new_title": "Neue Firma anlegen",
    "companies.name": "Firmenname",
    "companies.industry": "Branche",
    "companies.services": "Leistungen",
    "companies.tonality": "Tonalitaet",
    "companies.target_audience": "Zielgruppe",
    "companies.image_style": "Bildstil",
    "companies.forbidden": "Verbotene Aussagen",
    "companies.hashtag_rules": "Hashtag-Regeln",
    "companies.posts_week": "Posts / Woche",
    "companies.reels_week": "Reels / Woche",
    "companies.cta_label": "Call-to-Actions",
    "companies.empty": "Noch keine Firmen angelegt.",
    "companies.empty_hint": "Erstelle deine erste Firma, um loszulegen.",
    "companies.save": "Erstellen",
    "companies.update": "Aktualisieren",
    "companies.cancel": "Abbrechen",
    // Media
    "media.title": "Medienbibliothek",
    "media.subtitle": "Verwalte Bilder und Videos pro Firma",
    "media.upload_text": "Dateien hier ablegen oder klicken",
    "media.upload_hint": "Bilder und Videos (JPG, PNG, MP4)",
    "media.select_company": "Waehle oben eine Firma aus, um hochzuladen.",
    "media.empty": "Noch keine Medien vorhanden.",
    "media.ai_analyses": "KI-Analysen",
    "media.uploading": "Wird hochgeladen...",
    // Content Create
    "content.title": "Content erstellen",
    "content.subtitle": "Erstelle KI-gestuetzten Content Schritt fuer Schritt",
    "content.step_company": "Firma",
    "content.step_goal": "Ziel",
    "content.step_format": "Format",
    "content.step_media": "Medien",
    "content.step_generate": "Generieren",
    "content.step_edit": "Bearbeiten",
    "content.step_save": "Speichern",
    "content.select_company": "Firma auswaehlen",
    "content.goal_title": "Content-Ziel",
    "content.format_title": "Format waehlen",
    "content.media_title": "Medien waehlen (optional)",
    "content.generate_title": "KI-Content generieren",
    "content.summary": "Zusammenfassung",
    "content.generate_btn": "Jetzt generieren",
    "content.generating": "Wird generiert...",
    "content.save_draft": "Als Entwurf speichern",
    "content.submit_review": "Zur Pruefung einreichen",
    "content.back": "Zurueck",
    "content.next": "Weiter",
    "content.template_select": "Prompt-Template (optional)",
    "content.campaign_select": "Kampagne (optional)",
    "content.no_template": "Kein Template",
    "content.no_campaign": "Keine Kampagne",
    "content.caption_variants": "Caption-Varianten",
    "content.hook_variants": "Hook-Varianten",
    "content.reel_scenes": "Reel-Szenen",
    "content.hashtags": "Hashtags",
    "content.schedule_suggestion": "Posting-Vorschlag",
    "content.save_title": "Speichern & Planen",
    "content.date": "Datum (optional)",
    "content.time": "Uhrzeit",
    // Goals
    "goal.reichweite": "Reichweite",
    "goal.leads": "Leads",
    "goal.verkauf": "Verkauf",
    "goal.branding": "Branding",
    "goal.event": "Event-Bewerbung",
    "goal.saisonal": "Saisonale Aktion",
    // Formats
    "format.instagram_post": "Instagram Post",
    "format.facebook_post": "Facebook Post",
    "format.instagram_reel": "Instagram Reel",
    "format.facebook_reel": "Facebook Reel",
    "format.instagram_story": "Instagram Story",
    "format.facebook_story": "Facebook Story",
    // Status
    "status.draft": "Entwurf",
    "status.review": "Zur Pruefung",
    "status.approved": "Freigegeben",
    "status.scheduled": "Geplant",
    "status.published": "Veroeffentlicht",
    "status.failed": "Fehlgeschlagen",
    // Approval
    "approval.title": "Freigabe",
    "approval.subtitle": "Pruefe und gib Inhalte frei",
    "approval.pending": "Zur Pruefung",
    "approval.all_content": "Alle Inhalte",
    "approval.no_pending": "Keine Inhalte zur Pruefung vorhanden.",
    "approval.approve": "Freigeben",
    "approval.reject": "Ablehnen",
    "approval.schedule": "Planen",
    "approval.publish_now": "Jetzt posten",
    "approval.reuse": "Wiederverwenden",
    "approval.reuse_title": "Content wiederverwenden",
    "approval.reuse_generating": "KI generiert neue Varianten...",
    "approval.reuse_variants": "Neue Varianten",
    "approval.delete": "Loeschen",
    // Calendar
    "calendar.title": "Content-Kalender",
    "calendar.subtitle": "Geplante und veroeffentlichte Inhalte",
    // Weekly Planner
    "planner.title": "Wochenplaner",
    "planner.subtitle": "KI-gestuetzte Wochenplanung fuer deine Firmen",
    "planner.generate_title": "Neuen Wochenplan generieren",
    "planner.company": "Firma",
    "planner.week_start": "Woche ab",
    "planner.generate_btn": "Plan generieren",
    "planner.generating": "Wird generiert...",
    "planner.empty": "Noch keine Wochenplaene erstellt.",
    "planner.entries": "Eintraege",
    "planner.item_suggested": "Vorgeschlagen",
    "planner.item_approved": "Genehmigt",
    "planner.item_rejected": "Abgelehnt",
    // Campaigns
    "campaigns.title": "Kampagnen",
    "campaigns.subtitle": "Verwalte Marketing-Kampagnen fuer deine Firmen",
    "campaigns.add_btn": "Kampagne erstellen",
    "campaigns.new_title": "Neue Kampagne",
    "campaigns.edit_title": "Kampagne bearbeiten",
    "campaigns.name": "Kampagnen-Name",
    "campaigns.description": "Beschreibung",
    "campaigns.start": "Start",
    "campaigns.end": "Ende",
    "campaigns.goals": "Ziele",
    "campaigns.empty": "Noch keine Kampagnen erstellt.",
    "campaigns.empty_hint": "Erstelle z.B. \"Fruehlingsputz 2026\" oder \"Sommer-Challenge\".",
    // Performance
    "performance.title": "Performance",
    "performance.subtitle": "Analysiere die Leistung deiner Inhalte",
    "performance.refresh_btn": "Meta Insights aktualisieren",
    "performance.scheduler_active": "Auto-Scheduler aktiv",
    "performance.pending": "geplante Inhalte wartend",
    "performance.last_run": "Letzter Lauf",
    "performance.posts": "Posts",
    "performance.likes": "Likes",
    "performance.comments": "Kommentare",
    "performance.shares": "Shares",
    "performance.reach": "Reichweite",
    "performance.engagement": "Engagement",
    "performance.by_platform": "Engagement nach Plattform",
    "performance.top_content": "Top-Content",
    "performance.all_metrics": "Alle Metriken",
    "performance.empty": "Noch keine Performance-Daten. Veroeffentliche Content, um Metriken zu tracken.",
    "performance.edit": "Bearbeiten",
    "performance.save": "Speichern",
    // Team
    "team.title": "Team",
    "team.subtitle": "Verwalte Teammitglieder und deren Rollen",
    "team.members": "Teammitglieder",
    "team.no_members": "Keine Teammitglieder.",
    "team.role_admin": "Administrator",
    "team.role_manager": "Manager",
    "team.role_creator": "Content Creator",
    "team.role_viewer": "Betrachter",
    "team.permissions": "Rollen-Berechtigungen",
    "team.admin_desc": "Voller Zugriff, Team verwalten, Rollen aendern",
    "team.manager_desc": "Content freigeben und veroeffentlichen",
    "team.creator_desc": "Content erstellen, Medien hochladen",
    "team.viewer_desc": "Nur lesen, keine Aenderungen",
    // Providers
    "providers.title": "KI-Provider",
    "providers.subtitle": "Verwalte austauschbare KI-Provider fuer Content-Erstellung",
    "providers.add_btn": "Provider hinzufuegen",
    "providers.empty": "Keine Provider konfiguriert.",
    // Social
    "social.title": "Social Media Konten",
    "social.subtitle": "Verwalte Instagram- und Facebook-Konten pro Firma",
    "social.add_btn": "Konto hinzufuegen",
    "social.empty": "Noch keine Social-Media-Konten verknuepft.",
    // Templates
    "templates.title": "Prompt-Templates",
    "templates.subtitle": "Erstelle wiederverwendbare Vorlagen fuer die KI-Content-Erstellung",
    "templates.add_btn": "Template erstellen",
    "templates.empty": "Noch keine Templates erstellt.",
    "templates.empty_hint": "Templates helfen der KI, konsistente Inhalte zu generieren.",
    // Competitors
    "competitors.title": "Wettbewerber-Monitoring",
    "competitors.subtitle": "Analysiere Wettbewerber und finde differenzierende Content-Ideen",
    "competitors.add_btn": "Wettbewerber",
    "competitors.analyze_title": "KI-Wettbewerbsanalyse",
    "competitors.analyze_btn": "Analyse starten",
    "competitors.analyzing": "Wird analysiert...",
    "competitors.market_overview": "Marktuebersicht",
    "competitors.analysis": "Wettbewerber-Analyse",
    "competitors.opportunities": "Differenzierende Content-Ideen",
    "competitors.tips": "Positionierungs-Tipps",
    "competitors.avoid": "Vermeiden",
    "competitors.empty": "Noch keine Wettbewerber angelegt.",
    // A/B Tests
    "ab.title": "A/B Tests",
    "ab.subtitle": "Vergleiche Content-Varianten und finde die beste Version",
    "ab.create_btn": "Neuer A/B Test",
    "ab.empty": "Noch keine A/B Tests erstellt.",
    // General
    "general.all_companies": "Alle Firmen",
    "general.save": "Speichern",
    "general.cancel": "Abbrechen",
    "general.delete": "Loeschen",
    "general.edit": "Bearbeiten",
    "general.close": "Schliessen",
    "general.loading": "Wird geladen...",
    "general.error": "Fehler",
    "general.success": "Erfolgreich",
    "general.confirm_delete": "Wirklich loeschen?",
    "general.language": "Sprache",
    "nav.webhooks": "Webhooks",
    "nav.marketplace": "Marketplace",
    "nav.team_analytics": "Team-Analytics",
    "nav.admin_users": "Benutzerverwaltung",
    "nav.admin_llm_keys": "KI-API-Schluessel",
    "nav.admin_email": "E-Mail-Konfiguration",
    "nav.admin_feedback": "Feedback-Postfach",
  },

  "de-AT": {
    "nav.dashboard": "Dashboard",
    "nav.companies": "Firmen",
    "nav.media": "Medienbibliothek",
    "nav.content_create": "Content erstellen",
    "nav.weekly_planner": "Wochenplaner",
    "nav.campaigns": "Kampagnen",
    "nav.approval": "Freigabe",
    "nav.inbox": "Social-Inbox",
    "nav.calendar": "Kalender",
    "nav.performance": "Performance",
    "nav.ads_manager": "Ads Manager",
    "nav.group": "InvictaX Gruppe",
    "nav.leads": "Leads",
    "nav.google_ads": "Google Ads",
    "nav.ab_tests": "A/B Tests",
    "nav.competitors": "Mitbewerber",
    "nav.team": "Team",
    "nav.templates": "Prompt-Vorlagen",
    "nav.providers": "Modell-Routing",
    "nav.social_media": "Social Media",
    "nav.section_content": "Content",
    "nav.section_analytics": "Analyse & Team",
    "nav.section_settings": "Einstellungen",
    "nav.logout": "Abmelden",
    "login.title": "InvictaFlow Marketing",
    "login.welcome": "Willkommen",
    "login.subtitle": "Melde dich an, um das InvictaX Marketing OS zu verwalten.",
    "login.google_btn": "Mit Google anmelden",
    "login.footer": "Multi-Brand Content Management mit KI",
    "dashboard.title": "Dashboard",
    "dashboard.subtitle": "\u00dcberblick \u00fcber dein Marketing OS",
    "dashboard.companies": "Firmen",
    "dashboard.media": "Medien",
    "dashboard.content": "Content",
    "dashboard.in_review": "Zur Pr\u00fcfung",
    "dashboard.scheduled": "Geplant",
    "dashboard.published": "Ver\u00f6ffentlicht",
    "dashboard.campaigns": "Kampagnen",
    "dashboard.season_banner": "Aktuelle Themen",
    "dashboard.recent_content": "Neueste Inhalte",
    "dashboard.no_content": "Noch keine Inhalte erstellt.",
    "dashboard.topic_suggestions": "Themenvorschl\u00e4ge",
    "dashboard.select_company": "Firma w\u00e4hlen",
    "dashboard.suggestions_btn": "Vorschl\u00e4ge",
    "dashboard.suggestions_empty": "W\u00e4hle eine Firma und klicke \"Vorschl\u00e4ge\" f\u00fcr KI-gest\u00fctzte Themenideen.",
    "companies.title": "Firmenverwaltung",
    "companies.subtitle": "Verwalte deine Firmen und deren Markenprofile",
    "companies.add_btn": "Firma hinzuf\u00fcgen",
    "companies.empty": "Noch keine Firmen angelegt.",
    "companies.save": "Erstellen",
    "companies.update": "Aktualisieren",
    "companies.cancel": "Abbrechen",
    "status.draft": "Entwurf",
    "status.review": "Zur Pr\u00fcfung",
    "status.approved": "Freigegeben",
    "status.scheduled": "Geplant",
    "status.published": "Ver\u00f6ffentlicht",
    "status.failed": "Fehlgeschlagen",
    "approval.title": "Freigabe",
    "approval.subtitle": "Pr\u00fcfe und gib Inhalte frei",
    "approval.approve": "Freigeben",
    "approval.reject": "Ablehnen",
    "approval.publish_now": "Jetzt posten",
    "approval.reuse": "Wiederverwenden",
    "content.title": "Content erstellen",
    "content.subtitle": "Erstelle KI-gest\u00fctzten Content Schritt f\u00fcr Schritt",
    "content.generate_btn": "Jetzt generieren",
    "content.save_draft": "Als Entwurf speichern",
    "content.submit_review": "Zur Pr\u00fcfung einreichen",
    "goal.reichweite": "Reichweite",
    "goal.leads": "Leads",
    "goal.verkauf": "Verkauf",
    "goal.branding": "Branding",
    "goal.event": "Event-Bewerbung",
    "goal.saisonal": "Saisonale Aktion",
    "performance.title": "Performance",
    "performance.subtitle": "Analysiere die Leistung deiner Inhalte",
    "team.title": "Team",
    "team.subtitle": "Verwalte Teammitglieder und deren Rollen",
    "team.role_admin": "Administrator",
    "team.role_manager": "Manager",
    "team.role_creator": "Content Creator",
    "team.role_viewer": "Betrachter",
    "competitors.title": "Mitbewerber-Monitoring",
    "competitors.subtitle": "Analysiere Mitbewerber und finde differenzierende Content-Ideen",
    "competitors.analyze_btn": "Analyse starten",
    "general.all_companies": "Alle Firmen",
    "general.save": "Speichern",
    "general.cancel": "Abbrechen",
    "general.delete": "L\u00f6schen",
    "general.language": "Sprache",
    "nav.webhooks": "Webhooks",
    "nav.marketplace": "Marketplace",
    "nav.team_analytics": "Team-Analytics",
    "nav.admin_users": "Benutzerverwaltung",
    "nav.admin_llm_keys": "KI-API-Schluessel",
    "nav.admin_email": "E-Mail-Konfiguration",
    "nav.admin_feedback": "Feedback-Postfach",
  },

  "en": {
    "nav.dashboard": "Dashboard",
    "nav.companies": "Companies",
    "nav.media": "Media Library",
    "nav.content_create": "Create Content",
    "nav.weekly_planner": "Weekly Planner",
    "nav.campaigns": "Campaigns",
    "nav.approval": "Approval",
    "nav.inbox": "Social Inbox",
    "nav.calendar": "Calendar",
    "nav.performance": "Performance",
    "nav.ads_manager": "Ads Manager",
    "nav.group": "InvictaX Gruppe",
    "nav.leads": "Leads",
    "nav.google_ads": "Google Ads",
    "nav.ab_tests": "A/B Tests",
    "nav.competitors": "Competitors",
    "nav.team": "Team",
    "nav.templates": "Prompt Templates",
    "nav.providers": "Model Routing",
    "nav.social_media": "Social Media",
    "nav.section_content": "Content",
    "nav.section_analytics": "Analytics & Team",
    "nav.section_settings": "Settings",
    "nav.logout": "Sign out",
    "login.title": "InvictaFlow Marketing",
    "login.welcome": "Welcome",
    "login.subtitle": "Sign in to manage the InvictaX Marketing OS.",
    "login.google_btn": "Sign in with Google",
    "login.footer": "Multi-Brand Content Management with AI",
    "dashboard.title": "Dashboard",
    "dashboard.subtitle": "Overview of your Marketing OS",
    "dashboard.companies": "Companies",
    "dashboard.media": "Media",
    "dashboard.content": "Content",
    "dashboard.in_review": "In Review",
    "dashboard.scheduled": "Scheduled",
    "dashboard.published": "Published",
    "dashboard.campaigns": "Campaigns",
    "dashboard.season_banner": "Current Topics",
    "dashboard.recent_content": "Recent Content",
    "dashboard.no_content": "No content created yet. Start with \"Create Content\".",
    "dashboard.topic_suggestions": "Topic Suggestions",
    "dashboard.select_company": "Select company",
    "dashboard.suggestions_btn": "Suggest",
    "dashboard.suggestions_empty": "Select a company and click \"Suggest\" for AI-powered topic ideas.",
    "companies.title": "Company Management",
    "companies.subtitle": "Manage your companies and their brand profiles",
    "companies.add_btn": "Add Company",
    "companies.edit_title": "Edit Company",
    "companies.new_title": "New Company",
    "companies.name": "Company Name",
    "companies.industry": "Industry",
    "companies.services": "Services",
    "companies.tonality": "Tonality",
    "companies.target_audience": "Target Audience",
    "companies.image_style": "Image Style",
    "companies.forbidden": "Forbidden Statements",
    "companies.hashtag_rules": "Hashtag Rules",
    "companies.posts_week": "Posts / Week",
    "companies.reels_week": "Reels / Week",
    "companies.cta_label": "Call-to-Actions",
    "companies.empty": "No companies created yet.",
    "companies.empty_hint": "Create your first company to get started.",
    "companies.save": "Create",
    "companies.update": "Update",
    "companies.cancel": "Cancel",
    "media.title": "Media Library",
    "media.subtitle": "Manage images and videos per company",
    "media.upload_text": "Drop files here or click to upload",
    "media.upload_hint": "Images and videos (JPG, PNG, MP4)",
    "media.select_company": "Select a company above to upload.",
    "media.empty": "No media available yet.",
    "media.ai_analyses": "AI Analyses",
    "media.uploading": "Uploading...",
    "content.title": "Create Content",
    "content.subtitle": "Create AI-powered content step by step",
    "content.step_company": "Company",
    "content.step_goal": "Goal",
    "content.step_format": "Format",
    "content.step_media": "Media",
    "content.step_generate": "Generate",
    "content.step_edit": "Edit",
    "content.step_save": "Save",
    "content.select_company": "Select Company",
    "content.goal_title": "Content Goal",
    "content.format_title": "Choose Format",
    "content.media_title": "Select Media (optional)",
    "content.generate_title": "Generate AI Content",
    "content.summary": "Summary",
    "content.generate_btn": "Generate now",
    "content.generating": "Generating...",
    "content.save_draft": "Save as Draft",
    "content.submit_review": "Submit for Review",
    "content.back": "Back",
    "content.next": "Next",
    "content.template_select": "Prompt Template (optional)",
    "content.campaign_select": "Campaign (optional)",
    "content.no_template": "No Template",
    "content.no_campaign": "No Campaign",
    "content.caption_variants": "Caption Variants",
    "content.hook_variants": "Hook Variants",
    "content.reel_scenes": "Reel Scenes",
    "content.hashtags": "Hashtags",
    "content.schedule_suggestion": "Posting Suggestion",
    "content.save_title": "Save & Schedule",
    "content.date": "Date (optional)",
    "content.time": "Time",
    "goal.reichweite": "Reach",
    "goal.leads": "Leads",
    "goal.verkauf": "Sales",
    "goal.branding": "Branding",
    "goal.event": "Event Promotion",
    "goal.saisonal": "Seasonal Action",
    "format.instagram_post": "Instagram Post",
    "format.facebook_post": "Facebook Post",
    "format.instagram_reel": "Instagram Reel",
    "format.facebook_reel": "Facebook Reel",
    "format.instagram_story": "Instagram Story",
    "format.facebook_story": "Facebook Story",
    "status.draft": "Draft",
    "status.review": "In Review",
    "status.approved": "Approved",
    "status.scheduled": "Scheduled",
    "status.published": "Published",
    "status.failed": "Failed",
    "approval.title": "Approval",
    "approval.subtitle": "Review and approve content",
    "approval.pending": "Pending Review",
    "approval.all_content": "All Content",
    "approval.no_pending": "No content pending review.",
    "approval.approve": "Approve",
    "approval.reject": "Reject",
    "approval.schedule": "Schedule",
    "approval.publish_now": "Publish Now",
    "approval.reuse": "Reuse",
    "approval.reuse_title": "Reuse Content",
    "approval.reuse_generating": "AI is generating new variants...",
    "approval.reuse_variants": "New Variants",
    "approval.delete": "Delete",
    "calendar.title": "Content Calendar",
    "calendar.subtitle": "Scheduled and published content",
    "planner.title": "Weekly Planner",
    "planner.subtitle": "AI-powered weekly planning for your companies",
    "planner.generate_title": "Generate New Weekly Plan",
    "planner.company": "Company",
    "planner.week_start": "Week from",
    "planner.generate_btn": "Generate Plan",
    "planner.generating": "Generating...",
    "planner.empty": "No weekly plans created yet.",
    "planner.entries": "entries",
    "planner.item_suggested": "Suggested",
    "planner.item_approved": "Approved",
    "planner.item_rejected": "Rejected",
    "campaigns.title": "Campaigns",
    "campaigns.subtitle": "Manage marketing campaigns for your companies",
    "campaigns.add_btn": "Create Campaign",
    "campaigns.new_title": "New Campaign",
    "campaigns.edit_title": "Edit Campaign",
    "campaigns.name": "Campaign Name",
    "campaigns.description": "Description",
    "campaigns.start": "Start",
    "campaigns.end": "End",
    "campaigns.goals": "Goals",
    "campaigns.empty": "No campaigns created yet.",
    "campaigns.empty_hint": "Create e.g. \"Spring Cleaning 2026\" or \"Summer Challenge\".",
    "performance.title": "Performance",
    "performance.subtitle": "Analyze your content performance",
    "performance.refresh_btn": "Refresh Meta Insights",
    "performance.scheduler_active": "Auto-Scheduler active",
    "performance.pending": "scheduled items pending",
    "performance.last_run": "Last run",
    "performance.posts": "Posts",
    "performance.likes": "Likes",
    "performance.comments": "Comments",
    "performance.shares": "Shares",
    "performance.reach": "Reach",
    "performance.engagement": "Engagement",
    "performance.by_platform": "Engagement by Platform",
    "performance.top_content": "Top Content",
    "performance.all_metrics": "All Metrics",
    "performance.empty": "No performance data yet. Publish content to track metrics.",
    "performance.edit": "Edit",
    "performance.save": "Save",
    "team.title": "Team",
    "team.subtitle": "Manage team members and their roles",
    "team.members": "Team Members",
    "team.no_members": "No team members.",
    "team.role_admin": "Administrator",
    "team.role_manager": "Manager",
    "team.role_creator": "Content Creator",
    "team.role_viewer": "Viewer",
    "team.permissions": "Role Permissions",
    "team.admin_desc": "Full access, manage team, change roles",
    "team.manager_desc": "Approve and publish content",
    "team.creator_desc": "Create content, upload media",
    "team.viewer_desc": "Read-only, no changes",
    "providers.title": "AI Providers",
    "providers.subtitle": "Manage interchangeable AI providers for content creation",
    "providers.add_btn": "Add Provider",
    "providers.empty": "No providers configured.",
    "social.title": "Social Media Accounts",
    "social.subtitle": "Manage Instagram and Facebook accounts per company",
    "social.add_btn": "Add Account",
    "social.empty": "No social media accounts linked yet.",
    "templates.title": "Prompt Templates",
    "templates.subtitle": "Create reusable templates for AI content generation",
    "templates.add_btn": "Create Template",
    "templates.empty": "No templates created yet.",
    "templates.empty_hint": "Templates help the AI generate consistent content.",
    "competitors.title": "Competitor Monitoring",
    "competitors.subtitle": "Analyze competitors and find differentiating content ideas",
    "competitors.add_btn": "Competitor",
    "competitors.analyze_title": "AI Competitor Analysis",
    "competitors.analyze_btn": "Start Analysis",
    "competitors.analyzing": "Analyzing...",
    "competitors.market_overview": "Market Overview",
    "competitors.analysis": "Competitor Analysis",
    "competitors.opportunities": "Differentiating Content Ideas",
    "competitors.tips": "Positioning Tips",
    "competitors.avoid": "Avoid",
    "competitors.empty": "No competitors added yet.",
    "ab.title": "A/B Tests",
    "ab.subtitle": "Compare content variants and find the best version",
    "ab.create_btn": "New A/B Test",
    "ab.empty": "No A/B tests created yet.",
    "general.all_companies": "All Companies",
    "general.save": "Save",
    "general.cancel": "Cancel",
    "general.delete": "Delete",
    "general.edit": "Edit",
    "general.close": "Close",
    "general.loading": "Loading...",
    "general.error": "Error",
    "general.success": "Success",
    "general.confirm_delete": "Really delete?",
    "general.language": "Language",
  },
};

export const LANGUAGES = [
  { code: "de-CH", label: "Deutsch (CH)", flag: "CH" },
  { code: "de-AT", label: "Deutsch (AT)", flag: "AT" },
  { code: "en", label: "English", flag: "EN" },
];

export default translations;
